// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b6Fs","label":"styles_label__TKWel"};